import { Tag } from 'antd';
import { Button } from "components/Button";
import ExcelExportButton from "components/ExcelExportButton";
import FilterInput from "components/Form/filterInput";
import { useCallback,useEffect,useState } from "react";
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toTitleCase } from "utils/common";
import { leaveStatusOptions } from "utils/constants";
import { namesFor } from "components/Form/filterValues";
const EmployeeLeaveFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading, leaveTypes, appliedFilterCount, exportApiFn, exportParams, exportFilename}) => {
  const {
    userData, userDataLoading,
    department, costCenter, currentApprovers,
} = useSelector((state) => state.common);
const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{

    if(!userDataLoading ){

      console.log(filters, "LLLs")
      let _appliedFilters = [...filters].map(item=>{
        let label = ""
        let value = ""
        switch(item.key){
          case "leave_type":
            value = namesFor(searchParams.get("leave_type") || "", leaveTypes || [], t => t.value, t => t.label)
            label = "Leave type"
            break;
          case "company_user":
            value = namesFor(searchParams.get("company_user") || "", userData, u => u.id, u => `${u.first_name} ${u.last_name || ""}`.trim())
            label = "Employee"
            break;
          case "department":
            value = namesFor(searchParams.get("department") || "", department, d => d.id, d => d.name)
            label = "Department"
            break;
          case "cost_center":
            value = namesFor(searchParams.get("cost_center") || "", costCenter, cc => cc.id, cc => cc.name || cc.code)
            label = "Cost center"
            break;
          case "current_approver":
            value = namesFor(searchParams.get("current_approver") || "", currentApprovers, a => a.id, a => a.name)
            label = "Current approver"
            break;
          case "approval_status":
            let approval_status = toTitleCase(searchParams.get("approval_status") || "")
            let selected_status = [...leaveStatusOptions].find(item=>item.value ==  approval_status || "")
            value = approval_status
            label = "Approval status"
            break;
            case "search":
              value = toTitleCase(searchParams.get("search") || "")
              label = "Search term"
              break;
          case "user":
            let selectedUserData = [...userData].find(item=>item.id == searchParams.get("userData") || "")
            let user = toTitleCase(searchParams.get("userData") || "")
                
            value = user
            label = selectedUserData?.first_name+" "+selectedUserData?.last_name
            break;
        
          default:
            label = ""
            value = ""
        }
        return {
          ...item,
          value,
          label
        }
      })
    
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
    }

 
  },[
    userData,
    searchParams,
    leaveStatusOptions
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search" ){
      handleInputChange("", item.key, true)
    }
  }
  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-8 col-md-10">
          <div className="row" >
          <div className='col-sm-12 col-lg-4 ' >
        <FilterInput  
         defaultValue={setInputValue("search")} 
         onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
          id="search"
           label={searchPlaceholder}
            />
        </div>
        <div className='col-sm-12  col-lg-8  mt-1 flex-wrap' >
          
        {
            appliedFilters.map(item=>{
              return (
                <Tag icon={loading&&<i class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} className="mb-1" color={"red"} closable closeIcon={<i class="fa fa-times" aria-hidden="true"></i>} onClose={e=>handleClose(e, item)}>
                  {
                    item?.label
                  }
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              )
            })
          }

        </div>
          </div>
      

      
        </div>
      
 
        <div className="col-4 col-md-2 d-flex justify-content-end align-items-center" style={{ paddingRight: 0 }}>
        <div className="view-icons d-inline-flex align-items-center" style={{ gap: 4 }}>
          {exportApiFn && (
            <ExcelExportButton
              apiFn={exportApiFn}
              params={exportParams}
              filename={exportFilename}
            />
          )}
          <div className="position-relative">
            <Button
              onClick={handleFilterDrawer}
              icon="las la-filter"
              // id="collapse-header"
              className="list-view btn btn-link position-relative"
            />

            {appliedFilterCount ? (
              <span className="badge bg-danger position-absolute"
                style={{
                  top: "5px",
                  right: "5px",
                  transform: "translate(50%, -50%)",
                }}>
                {appliedFilterCount}
              </span>
            ) : <div />}
          </div>
        </div>
      </div>


      </div>
    </div>
  );
};

export default EmployeeLeaveFilter;
